<template>
  <div class="page-not-found">
    <Header />
    <div class="content">
      <h1>Not Found (404)</h1>
      <div>
        <p>Sorry, but the page you tried to visit doesn't exist any more or never did. Please start at the <a href="/">home page</a>.</p>
      </div>
    </div>
  </div>
</template>

<script>
import Header from './Header'
export default {
  components: {
    Header,
  },
}
</script>

<style>

</style>
